<template>
  <div>
    <!--Laboratory Card-->
    <div
      v-if="coreEntity === coreEntities.GENERAL.code"
      class="mx-3 mt-2"
    >
      <b-row
        style="width:100%"
        class="m-0"
      >
        <b-col class="pl-0 pr-0">
          <div class="entity-card">
            <b-row class="py-2 px-4">
              <b-col class="d-flex align-items-center">
                <span
                  class="entity-card__title d-flex align-items-center font-weight--medium"
                  qa="information-component-laboratory-label"
                >
                  <i
                    class="far fa-hospital mr-2"
                    aria-hidden="true"
                  />
                  {{ labName }}
                </span>
              </b-col>
            </b-row>
          </div>
        </b-col>
      </b-row>
    </div>

    <!--Request Card-->
    <div
      v-if="coreEntity === coreEntities.REQUEST.code && entityInformation"
      class="mx-3 mt-2"
    >
      <b-row
        style="width:100%"
        class="m-0"
      >
        <b-col class="pl-0 pr-0">
          <div class="entity-card">
            <b-row class="py-2 px-4">
              <b-col class="d-flex align-items-center">
                <span
                  class="entity-card__title d-flex align-items-center font-weight--medium"
                  qa="information-component-request-label"
                >
                  <i
                    class="far fa-file-medical mr-2"
                    aria-hidden="true"
                  />
                  {{ entityInformation.label }}
                </span>
              </b-col>
            </b-row>
            <div class="horizontal-divider" />
            <b-row class="py-2 px-4">
              <b-col
                class="entity-card__data"
              >
                <span class="entity-card__data--label">{{ $t('component.studyRequest.form.clinicCard.petitioner') }}</span>
                <span
                  class="entity-card__data--text"
                  qa="information-component-physician-petitioner"
                >{{ entityInformation.physicianPetitioner ? entityInformation.physicianPetitioner.fullName : '-' }}</span>
              </b-col>
              <b-col
                class="entity-card__data"
              >
                <span class="entity-card__data--label">{{ $t('component.incidentModal.center') }}</span>
                <span
                  class="entity-card__data--text"
                  qa="information-component-physician-center"
                >{{ entityInformation.physicianDepartment ? entityInformation.physicianDepartment.center.name : '-' }}</span>
              </b-col>
              <b-col
                class="entity-card__data"
              >
                <span class="entity-card__data--label">{{ $t('component.incidentModal.requestingUnit') }}</span>
                <span
                  class="entity-card__data--text"
                  qa="information-component-physician-department"
                >{{ entityInformation.physicianDepartment ? entityInformation.physicianDepartment.name : '-' }}</span>
              </b-col>
              <b-col
                class="entity-card__data"
              >
                <span class="entity-card__data--label">{{ $t('global.priority') }}</span>
                <span
                  class="entity-card__data--text"
                  qa="information-component-priority"
                >
                  <study-request-priority-dot
                    :priority-level="0"
                    :size="9"
                    show-label
                  />
                </span>
              </b-col>
            </b-row>
          </div>
        </b-col>
      </b-row>
    </div>
    <!--TODO: Hacer dinámicas las cabeceras en función de dónde se abran las incidencias-->
    <!--Patient Card-->
    <div
      v-if="coreEntity === coreEntities.PATIENT.code && entityInformation"
      class="mx-3 mt-2"
    >
      <b-row
        style="width:100%"
        class="m-0"
      >
        <b-col class="pl-0 pr-0">
          <div class="entity-card">
            <b-row class="py-2 px-3">
              <b-col class="d-flex align-items-center">
                <b-button
                  class="btn__icon btn__icon--primary"
                  @click="$emit('openModalPatientCard', entityInformation.id)"
                >
                  <i
                    class="far fa-user-circle mr-2 main"
                    aria-hidden="true"
                  />
                </b-button>
                <span
                  class="entity-card__title d-flex align-items-center font-weight--medium"
                  qa="information-component-patient-fullname"
                >
                  {{ entityInformation.fullName }}
                </span>
              </b-col>
            </b-row>
            <div class="horizontal-divider" />
            <b-row class="py-2 px-4">
              <b-col
                v-if="globalParameters.mainPatientIdentifierType"
                class="entity-card__data"
              >
                <span class="entity-card__data--label">{{ globalParameters.mainPatientIdentifierType.name }}</span>
                <span
                  class="entity-card__data--text"
                  qa="information-component-patient-main-identifier"
                >{{ entityInformation.mainPatientIdentifier ? entityInformation.mainPatientIdentifier.paiIdentifier : '-' }}</span>
              </b-col>
              <b-col
                class="entity-card__data"
              >
                <span class="entity-card__data--label">{{ globalParameters.secondaryPatientIdentifierType.name }}</span>
                <span
                  class="entity-card__data--text"
                  qa="information-component-patient-secondary-identifier"
                >{{ entityInformation.secondaryPatientIdentifier ? entityInformation.secondaryPatientIdentifier.paiIdentifier : '-' }}</span>
              </b-col>
              <b-col
                class="entity-card__data"
              >
                <span class="entity-card__data--label">{{ $t('entities.patient.gender') }}</span>
                <span
                  class="entity-card__data--text"
                  qa="information-component-patient-gender"
                >{{ entityInformation.gender.name }}</span>
              </b-col>
              <b-col
                class="entity-card__data"
              >
                <span class="entity-card__data--label">{{ $t('entities.patient.birthdate') }}</span>
                <span
                  class="entity-card__data--text"
                  qa="information-component-patient-birthdate"
                >{{ entityInformation.birthdate | date }}</span>
              </b-col>
              <b-col
                class="entity-card__data"
              >
                <span class="entity-card__data--label">{{ $t('global.age') }}</span>
                <span
                  class="entity-card__data--text"
                  qa="information-component-patient-age"
                >{{ patientTimeOld(entityInformation) }}</span>
              </b-col>
            </b-row>
          </div>
        </b-col>
      </b-row>
    </div>

    <!--Case Card-->
    <div
      v-if="coreEntity === coreEntities.CASE.code && entityInformation"
      class="mx-3 mt-2"
    >
      <b-row
        style="width:100%"
        class="m-0"
      >
        <b-col class="pl-0 pr-0">
          <div class="entity-card">
            <b-row class="py-2 px-4">
              <b-col class="d-flex align-items-center">
                <span
                  class="entity-card__title d-flex align-items-center font-weight--medium"
                  qa="information-component-case-label"
                >
                  <i
                    class="far fa-chart-network mr-2"
                    aria-hidden="true"
                  />
                  {{ entityInformation.casenumber }}
                </span>
              </b-col>
            </b-row>
            <div class="horizontal-divider" />
            <b-row class="py-2 px-4">
              <b-col
                class="entity-card__data"
              >
                <span class="entity-card__data--label">{{ $t('component.samplesModal.pathologist') }}</span>
                <span
                  class="entity-card__data--text"
                  qa="information-component-case-pathologist"
                >{{ entityInformation.pathologist ? entityInformation.pathologist.fullName : '-' }}</span>
              </b-col>
              <b-col
                class="entity-card__data"
              >
                <span class="entity-card__data--label">{{ $t('registry.cases.resident') }}</span>
                <span
                  class="entity-card__data--text"
                  qa="information-component-case-resident"
                >{{ entityInformation.resident ? entityInformation.resident.fullName : '-' }}</span>
              </b-col>
              <b-col
                class="entity-card__data"
              >
                <span class="entity-card__data--label">{{ $t('grid.detail.casRegistrationDate') }}</span>
                <span
                  class="entity-card__data--text"
                  qa="information-component-case-registration-date"
                >{{ entityInformation.registrationDate ? entityInformation.registrationDate : '-' | date }}</span>
              </b-col>
              <b-col
                class="entity-card__data"
              >
                <span class="entity-card__data--label">{{ $t('registry.cases.caseType') }}</span>
                <span
                  class="entity-card__data--text"
                  qa="information-component-case-type"
                >{{ entityInformation.caseType.descriptionInLaboratory }}</span>
              </b-col>
            </b-row>
          </div>
        </b-col>
      </b-row>
    </div>

    <!--Sample Card-->
    <div
      v-if="coreEntity === coreEntities.SAMPLE.code && entityInformation"
      class="mx-3 mt-2"
    >
      <b-row
        style="width:100%"
        class="m-0"
      >
        <b-col class="pl-0 pr-0">
          <div class="entity-card">
            <b-row class="py-2 px-4">
              <b-col class="d-flex align-items-center">
                <span
                  class="entity-card__title d-flex align-items-center font-weight--medium"
                  qa="information-component-sample-label"
                >
                  <i
                    class="far fa-prescription-bottle mr-2"
                    aria-hidden="true"
                  />
                  {{ entityInformation.sampleLabel }}
                </span>
              </b-col>
            </b-row>
            <div class="horizontal-divider" />
            <b-row class="py-2 px-4">
              <b-col
                class="entity-card__data"
              >
                <span class="entity-card__data--label">{{ $t('component.samplesModal.local') }}</span>
                <span
                  class="entity-card__data--text"
                  qa="information-component-sample-topographic-code"
                >{{ entityInformation.topographicCode.description }}</span>
              </b-col>
              <b-col
                class="entity-card__data"
              >
                <span class="entity-card__data--label">{{ $t('component.samplesModal.type') }}</span>
                <span
                  class="entity-card__data--text"
                  qa="information-component-sample-type"
                >{{ entityInformation.sampleType.description }}</span>
              </b-col>
              <b-col
                class="entity-card__data"
              >
                <span class="entity-card__data--label">{{ $t('component.samplesModal.dateSample') }}</span>
                <span
                  class="entity-card__data--text"
                  qa="information-component-sample-last-grossing-date"
                >{{ entityInformation.lastGrossingDate ? entityInformation.lastGrossingDate : '-' | date }}</span>
              </b-col>
              <b-col
                class="entity-card__data"
              >
                <span class="entity-card__data--label">{{ $t('component.samplesModal.grossingResponsible') }}</span>
                <span
                  class="entity-card__data--text"
                  qa="information-component-sample-grossing-responsible"
                >{{ entityInformation.responsibleForLastGrossing ? entityInformation.responsibleForLastGrossing.fullName : '-' }}</span>
              </b-col>
            </b-row>
          </div>
        </b-col>
      </b-row>
    </div>

    <!--Portion Card-->
    <div
      v-if="coreEntity === coreEntities.PORTION.code && entityInformation"
      class="mx-3 mt-2"
    >
      <b-row
        style="width:100%"
        class="m-0"
      >
        <b-col class="pl-0 pr-0">
          <div class="entity-card">
            <b-row class="py-2 px-4">
              <b-col class="d-flex align-items-center">
                <span
                  class="entity-card__title d-flex align-items-center font-weight--medium"
                  qa="information-component-portion-label"
                >
                  <i
                    :class="PORTION_TYPES[entityInformation.portionType.portionTypeEnum].icon"
                    class="mr-2"
                    aria-hidden="true"
                  />
                  {{ entityInformation.portionLabel }}
                </span>
              </b-col>
            </b-row>
            <div class="horizontal-divider" />
            <b-row class="py-2 px-4">
              <b-col
                class="entity-card__data"
              >
                <span class="entity-card__data--label">{{ $t('component.incidentModal.portionType') }}</span>
                <span
                  class="entity-card__data--text"
                  qa="information-component-portion-type"
                >{{ entityInformation.portionType.potName }}</span>
              </b-col>
              <b-col
                class="entity-card__data"
              >
                <span class="entity-card__data--label">{{ $t('grossing.portionGrid.requestDate') }}</span>
                <span
                  class="entity-card__data--text"
                  qa="information-component-request-date"
                >{{ entityInformation.requestDate | date }}</span>
              </b-col>
              <b-col
                class="entity-card__data"
              >
                <span class="entity-card__data--label">{{ $t('global.makingDate') }}</span>
                <span
                  class="entity-card__data--text"
                  qa="information-component-portion-generation-date"
                >{{ entityInformation.generationDate ? entityInformation.generationDate : '-' | date }}</span>
              </b-col>
              <b-col
                class="entity-card__data"
              >
                <span class="entity-card__data--label">{{ $t('laboratory.grid.confectionTech') }}</span>
                <span
                  class="entity-card__data--text"
                  qa="information-component-portion-generation-responsible"
                >{{ entityInformation.generationResponsiblePersonnel ? entityInformation.generationResponsiblePersonnel.fullName : '-' }}</span>
              </b-col>
            </b-row>
          </div>
        </b-col>
      </b-row>
    </div>

    <!--Subportion Card-->
    <div
      v-if="coreEntity === coreEntities.SUBPORTION.code && entityInformation"
      class="mx-3 mt-2"
    >
      <b-row
        style="width:100%"
        class="m-0"
      >
        <b-col class="pl-0 pr-0">
          <div class="entity-card">
            <b-row class="py-2 px-4">
              <b-col class="d-flex align-items-center">
                <span
                  class="entity-card__title d-flex align-items-center font-weight--medium"
                  qa="information-component-subportion-label"
                >
                  <i
                    class="icon-porta mr-2"
                    aria-hidden="true"
                  />
                  {{ entityInformation.subportionLabel }}
                </span>
              </b-col>
            </b-row>
            <div class="horizontal-divider" />
            <b-row class="py-2 px-4">
              <b-col
                class="entity-card__data"
              >
                <span class="entity-card__data--label">{{ $tc('global.technique', 1) }}</span>
                <span
                  class="entity-card__data--text"
                  qa="information-component-subportion-assay"
                >{{ entityInformation.assay.name }}</span>
              </b-col>
              <b-col
                class="entity-card__data"
              >
                <span class="entity-card__data--label">{{ $t('laboratory.tracking.requestDate') }}</span>
                <span
                  class="entity-card__data--text"
                  qa="information-component-request-date"
                >{{ entityInformation.requestDate | date }}</span>
              </b-col>
              <b-col
                class="entity-card__data"
              >
                <span class="entity-card__data--label">{{ $t('global.petitioner') }}</span>
                <span
                  class="entity-card__data--text"
                  qa="information-component-petitioner"
                >{{ entityInformation.requesterPersonnel ? entityInformation.requesterPersonnel.fullName : '-' }}</span>
              </b-col>
              <b-col
                class="entity-card__data"
              >
                <span class="entity-card__data--label">{{ $t('component.incidentModal.cutDate') }}</span>
                <span
                  class="entity-card__data--text"
                  qa="information-component-subportion-cut-date"
                >{{ entityInformation.cutDate ? entityInformation.cutDate : '-' | date }}</span>
              </b-col>
            </b-row>
          </div>
        </b-col>
      </b-row>
    </div>
  </div>
</template>

<script>
import StudyRequestPriorityDot from '@/modules/clinicalModule/components/StatusRequestPriorityDot'
import { COREENTITY_VALUES } from '@/api/resources/incident/incidentServices'
import { PORTION_TYPES } from '@/api/resources/portionTypeService'
import { StoreUtils } from '@/shared/util/store-utils'

export default {
    name: 'InformationComponent',
    components: { StudyRequestPriorityDot },
    props: {
        information: { type: Object, default: () => {} },
        coreEntity: { type: String, required: true },
        entitiesIds: { type: Object },
        entityInformation: { type: Object }
    },
    data() {
        return {
            laboratory: false
        }
    },
    computed: {
        PORTION_TYPES() {
            return PORTION_TYPES
        },
        coreEntities() {
            return COREENTITY_VALUES
        },
        fullName() {
            if (this.$store.getters.userInformation) {
                const {
                    name,
                    middleName,
                    surname1,
                    surname2
                } = this.$store.getters.userInformation
                return [name, middleName, surname1, surname2].join(' ')
            }
            return ''
        },
        labId() {
            return this.$store.getters.labId
        },
        labName() {
            return StoreUtils.selectedLaboratoryConfiguration?.laboratory.labName
        }
    },
    methods: {
        patientTimeOld(entityInformation) {
            if (entityInformation) return this.getPatientTimeOld(entityInformation.birthdate)
        }
    }
}
</script>

<style scoped>

h4{
  font-weight:normal;
}
.petitioner h4{
  margin-bottom:0;
}

.petitioner span{
  font-size: 0.9rem;
  position:relative;
  top: 0;
}

.information {
  background-color: #FFF;
  border: 1px solid rgba(0,0,0,.125);
  border-radius: .25rem;
}

.informationTitle {
  opacity: 0.5;
  font-family: 'Roboto', sans-serif;
  font-size: 12px;
  font-weight: 500;
  font-style: normal;
  font-stretch: normal;
  line-height: 1.67;
  letter-spacing: normal;
  color: #525252;
}

.roboto {
  font-family: 'Roboto', sans-serif;
}

.informationContent {
  font-family: 'Roboto', sans-serif;
  font-size: 14px;
  font-weight: 500;
  font-style: normal;
  font-stretch: normal;
  line-height: 1.67;
  letter-spacing: normal;
}

.informationRest {
  font-family: 'Roboto',sans-serif;
  font-size: 14px;
  font-weight: 500;
  font-style: normal;
  font-stretch: normal;
  line-height: 1.67;
  letter-spacing: normal;
  color: #525252;
}
</style>
